import { AiOutlineClose } from "react-icons/ai";

import ModalLayout from "@/components/Layout/ModalLayout";
import TypeBadge from "@/pages/Dashboard/components/TypeBadge";
import type { UnifiedRow } from "@/pages/Dashboard/shared";
import { cn } from "@/utils/cn";

interface UserReservationDetailModalProps {
  row: UnifiedRow;
  onClose: () => void;
}

const UserReservationDetailModal = ({
  row,
  onClose,
}: UserReservationDetailModalProps) => (
  <ModalLayout variant="primary" onClose={onClose}>
    <div className="flex w-[calc(100vw-32px)] flex-col sm:w-[420px]">
      <div className="flex items-center justify-between border-b border-gray-100 px-6 py-4">
        <div className="flex items-center gap-2">
          <h3 className="text-base font-bold text-gray-900">
            {row.type === "place" ? "장소 예약 상세" : "차량 예약 상세"}
          </h3>
          <TypeBadge type={row.type} />
        </div>
        <button
          type="button"
          onClick={onClose}
          className="rounded-md p-1 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600"
        >
          <AiOutlineClose size={16} />
        </button>
      </div>
      <div className="px-6 py-5">
        <div className="flex flex-col">
          <div className="flex items-baseline border-b border-gray-100 py-3 text-sm">
            <div className="w-20 shrink-0 font-medium text-gray-500">상태</div>
            <span
              className={cn(
                "rounded-full px-2.5 py-0.5 text-xs font-medium",
                row.statusClass,
              )}
            >
              {row.statusLabel}
            </span>
          </div>
          <div className="flex items-baseline border-b border-gray-100 py-3 text-sm">
            <div className="w-20 shrink-0 font-medium text-gray-500">날짜</div>
            <div className="text-gray-800">{row.fullDate}</div>
          </div>
          <div className="flex items-baseline border-b border-gray-100 py-3 text-sm">
            <div className="w-20 shrink-0 font-medium text-gray-500">시간</div>
            <div className="text-gray-800">{row.time}</div>
          </div>
          <div className="flex items-baseline border-b border-gray-100 py-3 text-sm">
            <div className="w-20 shrink-0 font-medium text-gray-500">
              {row.type === "place" ? "장소" : "목적지"}
            </div>
            <div className="text-gray-800">{row.name}</div>
          </div>
          <div className="flex items-baseline border-b border-gray-100 py-3 text-sm">
            <div className="w-20 shrink-0 font-medium text-gray-500">
              {row.type === "place" ? "사용 목적" : "운행 목적"}
            </div>
            <div className="text-gray-800">{row.detail || "-"}</div>
          </div>
          <div className="flex items-baseline border-b border-gray-100 py-3 text-sm">
            <div className="w-20 shrink-0 font-medium text-gray-500">
              {row.type === "place" ? "예약자" : "신청자"}
            </div>
            <div className="text-gray-800">{row.userName}</div>
          </div>
          <div className="flex items-baseline py-3 text-sm">
            <div className="w-20 shrink-0 font-medium text-gray-500">
              연락처
            </div>
            <div className="text-gray-800">{row.telNo}</div>
          </div>
        </div>
      </div>
      <div className="flex justify-end border-t border-gray-100 px-6 py-4">
        <button
          type="button"
          onClick={onClose}
          className="rounded-lg bg-primary px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-primary/90"
        >
          확인
        </button>
      </div>
    </div>
  </ModalLayout>
);

export default UserReservationDetailModal;
